module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAAApCAMAAAAWCqXoAAAAUVBMVEUAAADNzc3KysrMzMzm5ubPz8/MzMzMzMzMzMzY2NjMzMzLy8vMzMzNzc3MzMzOzs7MzMzNzc3MzMzMzMzNzc3Ly8vNzc3MzMzMzMzMzMzMzMzPj9pDAAAAG3RSTlMAp1fpBRTh1bgNyJiIajcqHrGheF9YSEL0UJANY0mHAAAAnklEQVRo3u3YyRWDMBAE0ZYFkljFKsD5B+obNycwpX+aDHpeieDaRNCfAjh6AXR+FsA4CGDxrQDWXQAlNrKviUUAUxJAe2cBDF8BZN8JIE0COBljEq73/tjlnF7OrPVeBOBGAcwBMSa1jNhBKSOIZlnLiCElIJ7Z+AgAUkY8o4wgMntmjAmjjDy4MmLY7gTQekQZ2WoZsSMdIvj3GPwAnVIHEv7yMxIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/common/left.png
// module id = pbjZ
// module chunks = 41